"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertBytesToString = void 0;
var convertBytesToString = function (bytes, precision) {
    if (precision === void 0) { precision = 1; }
    var localBytes = bytes;
    var thresh = 1000;
    if (Math.abs(localBytes) < thresh) {
        return "".concat(localBytes, " B");
    }
    var units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var u = -1;
    var r = Math.pow(10, precision);
    do {
        localBytes /= thresh;
        u += 1;
    } while (Math.round(Math.abs(localBytes) * r) / r >= thresh && u < units.length - 1);
    return "".concat(localBytes.toFixed(precision), " ").concat(units[u]);
};
exports.convertBytesToString = convertBytesToString;
//# sourceMappingURL=Bytes.js.map